<template>
  <div class="info-course">
    <div class="container-fluid">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-row>
            <v-col cols="12" sm="12" md="2" lg="2" class="thumb-brand-school">
              <img :src="course.user.imageUrl" v-if="course.user.imageUrl" class="user-thumb">
              <div class="thumb-brand-school-default" v-else></div>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <p class="info-course-prod">Produzido por</p>
              <h3>{{ course.user.name }}</h3>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <!--<p class="price-offer" style="margin-bottom: 0;">R$245,00</p><br/>-->
              <p class="price" v-if="course.price">R${{ priceValue }},<span>{{ priceCents }}</span></p>
              <p class="price-free" v-else>Gratuito</p>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2" class="text-right">
              <v-btn class="btn-compra-app" color="#94c858" dark v-if="!course.isPublic && !userHasCourse"
                     @click="buyCourse"
                     :loading="loadingAdd"
                     :disabled="loadingAdd">Compre agora
              </v-btn>
              <v-btn color="#94c858" dark v-else @click="addCourse" :loading="loadingAdd" :disabled="loadingAdd">
                Acesse já
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { priceDivider } from '@/helpers'
import { CourseModel } from '@/models/Course'

// function Course (title, description, price, priceWithTax, isPublic, videoIntro, modules, contents, user) {
//   this.title = title
//   this.description = description
//   this.price = price
//   this.priceWithTax = priceWithTax
//   this.isPublic = isPublic
//   this.videoIntro = videoIntro
//   this.modules = modules
//   this.contents = contents
//   this.user = user
// }

export default {
  name: 'CoursePageHeader',
  props: {
    course: CourseModel,
    userHasCourse: {
      type: Boolean,
      require: false,
      default: false
    },
    loadingAdd: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  computed: {
    priceValue () {
      return priceDivider(this.course.priceWithTax).value
    },
    priceCents () {
      const cents = priceDivider(this.course.priceWithTax).cents

      return cents || '00'
    }
  },
  methods: {
    addCourse () {
      this.$emit('addCourse')
    },
    buyCourse () {
      this.$emit('buyCourse')
    }
  }
}
</script>

<style scoped>
.user-thumb {
  max-width: 180px;
  max-height: 180px;
  position: absolute;
  top: -60px;
  border: 5px solid #fff;
  border-radius: 20px;
}
</style>
